import * as React from 'react';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import firebase from "firebase/app";

import Loader from './../../component/common/Loader';
import { onChange, validateForm, setStorage } from './../../utils';
import CONSTANT from './../../constant';
import { getVendorDetail } from './../../action/VendorAction';
import { addActivity } from './../../action/ActivityAction';
import { resendOTP } from './../../action/AuthAction';

class Login extends React.Component<any, any> {
    constructor(props: any) {
        super(props);
        this.state = {
            email: { name: 'email', value: '', error: '', isRequired: true },
            password: { name: 'password', value: '', error: '', isRequired: true },
            showLoader: false
        };
    }

    public render() {
        const { email, password, showLoader, remember } = this.state;
        return (
            <React.Fragment>
                {
                    showLoader && <Loader />
                }
                <div className="container-fluid page-body-wrapper full-page-wrapper login-bg">
                    <div className="row flex-grow justify-content-center">
                        <div className="col-sm-6 loginLeft align-items-center justify-content-center p-0 d-flex">
                            <div className="logo-strip flex-fill">
                                <div className="brand-logo">
                                    <img src="/assets/images/logo_large.png" />
                                    <h2 className="text-white mt-4 mb-0 d-none d-lg-block">The wait is over...</h2>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-6 loginRight">
                            <form className="justify-content-between" onSubmit={this.submitForm}>
                                <div className="fhead d-flex justify-content-between">
                                    <h2 className="text-white flex-fill">Login</h2>
                                </div>
                                <div className="fbody auth-form-light text-left">
                                    <div className="form-group over-label mb-5">
                                        <div className="bottom-line">
                                            <input
                                                className={email.error.length > 0 ? "form-control is-invalid" : "form-control"}
                                                type="email"
                                                name={email.name}
                                                value={email.value}
                                                onChange={this.onChange}
                                            />
                                            <label className="text-white">Email id</label>
                                        </div>
                                    </div>
                                    <div className="form-group over-label password-field mb-4_">
                                        <div className="bottom-line">
                                            <input
                                                className={password.error.length > 0 ? "form-control is-invalid" : "form-control"}
                                                type="password"
                                                name={password.name}
                                                value={password.value}
                                                onChange={this.onChange}
                                            />
                                            <label className="text-white">Password</label>
                                            <i className="showPassword text-white"></i>
                                        </div>
                                    </div>
                                    <div className="mb-5 text-center text-lg-left">
                                        <a className="auth-link font-weight-600 text-primary h4" href={CONSTANT.url.forgotPassword}>Forgot Password?</a>
                                    </div>
                                    <button type="submit" className="btn btn-block btn-primary btn-lg font-weight-medium auth-form-btn">Login</button>
                                </div>
                                <div className="ffoot text-center text-lg-left">
                                    <p className="mb-0 h4 text-white">Don't have an account? <a className="text-primary" href="#" onClick={this.onSignup}>Sign Up</a></p>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
                <ToastContainer
                    position="top-right"
                    autoClose={3000}
                    hideProgressBar={true}
                    pauseOnHover
                />
            </React.Fragment>
        )
    }

    private onChange = (e: any) => {
        const name = e.target.name;
        const value = e.target.value;

        onChange(this, name, value);
    }

    private onSignup = (e: any) => {
        e.preventDefault();
        window.location.href = CONSTANT.url.register;
    }

    private submitForm = async (e: any) => {
        e.preventDefault();
        if (validateForm(this)) {
            const st = this.state;
            const model = {
                email: st.email.value,
                password: st.password.value
            };
            this.setState({ showLoader: true });
            firebase.app().auth().signInWithEmailAndPassword(model.email, model.password).then(async (result: any) => {
                if (result) {
                    const userDetail = await getVendorDetail({ uid: result.user.uid });
                    if (userDetail && userDetail.status === 200) {
                        if (userDetail && userDetail.data.role === "user") {
                            this.setState({ showLoader: false });
                            setStorage(CONSTANT.keys.token, userDetail.data.token);
                            setStorage(CONSTANT.keys.userDetail, { uid: userDetail.data.uid, displayName: userDetail.data.displayName, email: userDetail.data.email, photoURL: userDetail.data.photoURL });
                            if (userDetail.data.isVendorPlanSubscribed) {
                                window.location.href = CONSTANT.url.dashboard;
                            } else {
                                if (userDetail.data.signupSteps == 1) {
                                    await this.onResendOTP(userDetail.data.uid);
                                } else if (userDetail.data.signupSteps == 2) {
                                    window.location.href = CONSTANT.url.buyProduct;
                                } else if (userDetail.data.signupSteps == 3) {
                                    window.location.href = CONSTANT.url.buyProduct;
                                }
                            }
                        } else {
                            this.setState({ showLoader: false });
                            toast.error("You are not authorized to login");
                        }
                    } else if (userDetail && userDetail.status === 400) {
                        this.setState({ showLoader: false });
                        toast.error(userDetail.message);
                    }
                }
            }).catch((error: any) => {
                this.setState({ showLoader: false });
                if (error && error.code === "auth/user-not-found") {
                    toast.error(error.message);
                }
                if (error && error.code === "auth/wrong-password") {
                    toast.error(error.message);
                }
            });
        }
    }

    private onResendOTP = async (uid: any) => {
        const { email } = this.state;
        const model = {
            email: email.value,
            validateType: "verifyEmail",
        };
        this.setState({ showLoader: true });
        resendOTP(model).then((res: any) => {
            this.setState({ showLoader: false });
            if (res.status === 200) {
                window.location.href = `${CONSTANT.url.registerVerification}?i=${uid}`;
            }
            if (res.status === 400) {
                toast.error(res.message);
            }
        }).catch((error: any) => {
            this.setState({ showLoader: false });
        });

    }
}

export default Login;